import { ContainerModule } from 'inversify';
import AdapterFactory from '@framework/di/Providers/Rpc/AdapterFactory';
import { RpcDispatcher } from '../RpcDispatcher';
import { WebServiceRpcDispatcher } from '../WebServiceRpcDispatcher';
import DITypes from './types';
import type { IRpcDispatcher, IAdapterFactory } from './interfaces';

export const DispatcherModule = new ContainerModule(({ bind }) => {
  bind<IAdapterFactory>(DITypes.AdapterFactory).to(AdapterFactory).inSingletonScope();

  bind<IRpcDispatcher>(DITypes.RpcDispatcher).to(RpcDispatcher).inSingletonScope();
  bind<IRpcDispatcher>(DITypes.WebServiceRpcDispatcher).to(WebServiceRpcDispatcher).inSingletonScope();
});
